import { __decorate, __metadata } from "tslib";
import { UseRestraints } from '@core/shared/restraints';
import { Expose, ItemModel, ItemModelDefinition, Model, ModelId } from '@core/shared/model';
import { ExamResultRestraints } from './exam-result.restraints';
export var ExamRefreshPriority = /*#__PURE__*/function (ExamRefreshPriority) {
  ExamRefreshPriority["NONE"] = "NONE";
  ExamRefreshPriority["REQUIRED"] = "REQUIRED";
  ExamRefreshPriority["URGENT"] = "URGENT";
  ExamRefreshPriority["UNKNOWN"] = "UNKNOWN";
  return ExamRefreshPriority;
}(ExamRefreshPriority || {});
let ExamResultItem = /*#__PURE__*/(() => {
  let ExamResultItem = class ExamResultItem extends ItemModel {
    toString() {
      return "ExamResult ";
    }
  };
  __decorate([Expose(), __metadata("design:type", Number)], ExamResultItem.prototype, "id", void 0);
  __decorate([Expose(), __metadata("design:type", Object)], ExamResultItem.prototype, "creationDate", void 0);
  __decorate([Expose(), __metadata("design:type", Number)], ExamResultItem.prototype, "ownerId", void 0);
  __decorate([Expose(), __metadata("design:type", Number)], ExamResultItem.prototype, "courseId", void 0);
  __decorate([Expose(), __metadata("design:type", Boolean)], ExamResultItem.prototype, "passed", void 0);
  __decorate([Expose(), __metadata("design:type", Number)], ExamResultItem.prototype, "score", void 0);
  ExamResultItem = __decorate([ItemModelDefinition({
    texts: {
      item: 'Prüfungsergebnis',
      items: 'Prüfungsergebnisse'
    }
  }), UseRestraints(ExamResultRestraints), ModelId("ExamResultItem") // auto-generated by generate-model-ids
  ], ExamResultItem);
  return ExamResultItem;
})();
export { ExamResultItem };
let ExamResultStatus = /*#__PURE__*/(() => {
  let ExamResultStatus = class ExamResultStatus extends Model {};
  __decorate([Expose(), __metadata("design:type", Object)], ExamResultStatus.prototype, "lastPassedDate", void 0);
  __decorate([Expose(), __metadata("design:type", String)], ExamResultStatus.prototype, "refreshPriority", void 0);
  __decorate([Expose(), __metadata("design:type", Number)], ExamResultStatus.prototype, "failedTriesWithinTimeout", void 0);
  __decorate([Expose(), __metadata("design:type", Boolean)], ExamResultStatus.prototype, "isTimeout", void 0);
  ExamResultStatus = __decorate([ModelId("ExamResultStatus") // auto-generated by generate-model-ids
  ], ExamResultStatus);
  return ExamResultStatus;
})();
export { ExamResultStatus };